import { handleJsonResponse, getFilterQuery, addSortingQuery } from "./api";
import config from '../config';
import { getUser } from '../auth';


export async function getJobTasks(id, filters, sorting, start = 0, limit = 10){
  const user = getUser();
  const token = user?.access_token;
  
  if (filters['index'])
  {
    filters['index'].filter = filters['index'].filter - 1;
  }
  
  var filterQuery = getFilterQuery(filters);
  if (filterQuery.length > 0)
  {
    filterQuery = "filter=" + filterQuery;
  }
  
  filterQuery = addSortingQuery(filterQuery, sorting);

  let response;
  try {
    response = await fetch(`${config.API_URL}/jobs/${id}/tasks?start=${start}&limit=${limit}&${filterQuery}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } finally {
    if (filters['index'])
    {
      filters['index'].filter = filters['index'].filter + 1;
    }
  }

  return handleJsonResponse(response);
}